<script>
  import VueCharts from 'vue-chartjs'

  export default {
    extends: VueCharts.Doughnut,
    mixins: [VueCharts.mixins.reactiveProp],
    props: {
      chartdata: {
        type: Object,
        default: null
      },
      options: {
        type: Object,
        default: null
      }
    },
    mounted () {
      this.renderChart(this.chartData, this.options)
    }
  }
</script>

<style>
</style>